<template>
  <!-- 添加职业经历 -->
   <div class="add-experience">
       <div class="tips">
           <div class="bar"></div>
       </div>
       <!-- main -->
       <div class="main">
           <div class="row">
               <label for="">公司名称</label>
                <div v-if="!form.corporate_name" @click="toFormEdit('公司名称')" class="select">
                    请输入<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
                <div @click="toFormEdit('公司名称','corporate_name')" v-else class="text">
                    <div class="t">{{form.corporate_name}}</div>
                    <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
           </div>
           <div class="row">
               <label for="">时间</label>
               <div   class="date">
                  <span :class="[time[0]?'on':'']" @click="showTime(0)">{{time[0]?time[0]:'开始时间'}}--</span><span :class="[time[1]?'on':'']" @click="showTime(1)">{{time[1]?time[1]:'结束时间'}}</span>
              </div>
           </div>
           <div class="row">
                <label for="">职业类型</label>
                <div v-if="!form.profession" @click="toFormEdit('职业类型','profession')" class="select">
                    请输入<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
                <div @click="toFormEdit('职业类型','profession')" v-else class="text">
                    <div class="t">{{form.profession}}</div>
                    <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
           </div>
           <div class="row">
               <label for="">所在行业</label>
                <div v-if="!form.industry" @click="toFormEdit('所在行业','industry')" class="select">
                    请输入<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
                <div @click="toFormEdit('所在行业','industry')" v-else class="text">
                    <div class="t">{{form.industry}}</div>
                    <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
           </div>
           <div class="row">
               <label for="">工作内容</label>
                <div v-if="!form.job_content" @click="toFormEdit('工作内容','job_content')" class="select">
                    请输入<img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
                <div @click="toFormEdit('工作内容','job_content')" v-else class="text">
                    <div class="t">{{form.job_content}}</div>
                    <img class="right" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/right-icon.png" alt="">
                </div>
           </div>
       </div>
        <!--  -->
      <div class="footer">
          <button @click="saveHandle()">保存</button>
      </div>
    <!-- 弹出信息 -->
      <van-popup v-model="popShow" position="bottom"   @close="pickerShowClick(false)" >
          <van-picker  show-toolbar :columns="columns" @confirm="cityCfm" @cancel="popShow=false" />
      </van-popup>
   </div>
</template>

<script>
import { orderGet,saveInfo } from "@/api/xuandui_gadgets"
import { getSessionStorage, setSessionStorage, deleteSessionStorage} from '@/utils/tools'
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            time:[],
            keys:{
                corporate_name:'公司名称',
                profession:'职业类型',
                industry:'所在行业',
                job_content:'工作内容'
            },
            form:{
                corporate_name:'',
                profession:'',
                industry:'',
                job_content:''
            },
            timeIdx:0,
            popShow:false,
            collectionList:[],
            item:{},
            columns:[],
            // 第几个工作经历，默认第一个
            experience_idx:0
        }
    },
    destroyed(){
        deleteSessionStorage('/xd_add_experience');
    },
    methods:{
        // 提交资料
        saveHandle(){
            let q = this.$route.query;
            let fild = Object.keys(this.form);
            let arr = [];
            if(this.time.length<2){
                this.$toast('时间不能为空！');
                return
            }
            fild.map(v=>{
                if(!this.form[v]){
                    this.$toast('信息不能为空！');
                    return
                }
                arr.push({
                    label:this.keys[v],
                    value:this.form[v]
                });
            });
            arr.push({
                label:'时间',
                value:this.time[0]+'^'+this.time[1]
            });
            let info = JSON.parse(this.item.collection)?JSON.parse(this.item.collection):[];
            let arrlist = [];

            info.map((v,index)=>{
                if(v.label=='职业经历'){
                    // 判断是否存在职业经历数组下标 ，存在即是修改，不存在则是添加
                    if(q.eidx){
                        v.value[q.eidx] = arr;
                        arrlist = [{
                            label:'职业经历',
                            value:[...v.value]
                        }];
                    }else{
                        arrlist = [{
                            label:'职业经历',
                            value:[arr,...v.value]
                        }];
                    }
                    
                }
            });
            // 提交数据
            saveInfo({
                order_id:this.item.id,
                collection:JSON.stringify(arrlist)
            }).then((data)=>{
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.$toast('保存成功！');
                deleteSessionStorage('/xd_add_experience');
                this.$router.push('/xd_ef');
            });
        },
        // 跳转填写表单信息
        toFormEdit(val,name){
            setSessionStorage('/xd_add_experience',name,this.form[name]);
            this.$router.push({
                path:'/xd_add_eform',
                query:{
                    title:val
                }
            });
            
        },
        // 显示时间
        showTime(idx){
            this.timeIdx = idx;
            this.popShow = true;
        },
        /*
        *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
        *@MethodAuthor:  Zhang Xiao Guang
        *@Date: 2019-11-28 12:18:35
        */
        pickerShowClick(newval) {
            let self = this;
            if (newval) {
                document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
                    passive: false
                }); //阻止默认事件
            } else {

                document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
                    passive: false
                }); //打开默认事件
            }
        },
        // 确认选择触发
        cityCfm(picker) {
            if(picker instanceof Array){
                this.time[this.timeIdx] = picker[0]+'/'+ picker[1];
                setSessionStorage('/xd_add_experience',`time${this.timeIdx}`,picker[0]+'/'+ picker[1]);
            }
            this.popShow = false;
        },
        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            let q = this.$route.query;
            let obj = {
                id:q.oid
            };
            orderGet(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                
                this.item = data.item;
               
                // 判断是第几个职业经历，没有则为第一个
                if(q.eidx || q.eidx==0){
                    this.experience_idx = q.eidx;
                    let info = JSON.parse(this.item.collection)?JSON.parse(this.item.collection):[];
                    let keys_ = Object.keys(this.keys);
                    if(info[0]){
                        
                        info[0].value[this.experience_idx].map((v,idx)=>{
                            keys_.map((k,kidx)=>{
                                // 时间
                                if(v.label=='时间'){
                                    this.time = v.value.split('^');
                                }else{
                                    if(v.label==this.keys[k]){
                                        this.form[k] = v.value;
                                    }
                                }
                                
                            });
                        });
                    }
                    
                }

                let corporate_name = getSessionStorage('/xd_add_experience','corporate_name');
                let profession = getSessionStorage('/xd_add_experience','profession');
                let industry = getSessionStorage('/xd_add_experience','industry');
                let job_content = getSessionStorage('/xd_add_experience','job_content');
                let time0 = getSessionStorage('/xd_add_experience','time0');
                let time1 = getSessionStorage('/xd_add_experience','time1');

                if(corporate_name){
                    this.form.corporate_name = corporate_name;
                } 
                if(profession){
                    this.form.profession = profession;
                }
                if(industry){
                    this.form.industry = industry;
                } 
                if(job_content){
                    this.form.job_content = job_content;
                }
                if(time0 || time1){
                    this.time = [time0,time1];
                }
                

                document.title = '基本信息';

                // 处理年份数据
                if(this.columns.length<=0){
                    let date = new Date();
                    let yesr_ = date.getFullYear(); //获取完整的年份(4位)
                    let arr = [];
                    for(let i=yesr_;i>=1900;i--){
                        arr.push(i);
                    }
                    
                    this.columns = [// 第一列 年份
                        {
                            values: arr,
                            defaultIndex: 2,
                        },
                        // 第二列 月份
                        {
                            values: [1,2,3,4,5,6,7,8,9,10,11,12],
                            defaultIndex: 1,
                        }
                    ];
                }
            })
            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #F7F8F9;
    }
    .add-experience{
        .van-cell{
            padding: 0;
            text-align: right;
            textarea{
                text-align: right;
            }
        }
    }
    
</style>
<style lang="scss" scoped>
.add-experience{
    position: relative;
    .tips{
        width: 100%;
        height: 8px;
        overflow: hidden;
        background-color: #ECECEC;
        .bar{
            background: #46A3FA;
            width: 200px;
            height: 100%;
        }
    }
    .main{
        padding: 30px 30px 160px;
        .row{
            display: flex;
            align-items: center;
            min-height: 98px;
            overflow: hidden;
            background: #FFFFFF;
            border-radius: 20px;
            margin-bottom: 20px;
            padding: 0 30px;
            &:last-of-type{
                margin-bottom: 0;
            }
            label{
                font-size: 28px;
                color: #7D8289;
                font-weight: 400;
                margin-right: auto;
            }
            .select{
                display: flex;
                align-items: center;
                font-size: 24px;
                color:#A9AFB3;
                .right{
                    width: 24px;
                    height: 24px;
                    margin-left: 10px;
                }
            }
            .date{
                font-size: 24px;
                color: #A9AFB3;
                .on{
                    font-size: 30px;
                    font-weight: 400;
                    color: #2B333A;
                }
            }
            .text{
                font-size: 30px;
                font-weight: 500;
                color: #2B333A;
                line-height: 46px;
                display: flex;
                align-items: center;
                .t{
                    width: 404px;
                    text-align: right;
                }
                img{
                    margin-left: 10px;
                }
            }
        }
    }
    .footer{
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 750px;
        background-color: #FFFFFF;
        button{
            width: 670px;
            height: 80px;
            background: #46A3FA;
            border-radius: 40px;
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 44px;
            letter-spacing: 1px;
            border: none;
        }
    }
}
</style>

